// La sala, tal como está montada: 20 bicis en cuatro filas.
//
//            1      ★ coach      2
//            ● ● ●        ● ●              (5, con el pasillo en medio)
//          ● ● ● ● ● ●                     (6)
//        ● ● ● ● ● ● ●                     (7)
//
// Cambiar la distribución es cambiar FILAS: el dibujo, la numeración y los
// sitios que se pueden elegir salen todos de aquí.
const CX = 400;

const FILAS = [
  // Las dos de delante van a los lados del coach, no en fila con las demás.
  { y: 70, start: 1, xs: [CX - 118, CX + 118] },
  // La fila de 5 va partida 3 + 2, con el pasillo por el medio.
  { y: 195, start: 3, count: 5, gap: 92, pasilloTras: 3, pasillo: 72 },
  { y: 305, start: 8, count: 6, gap: 92 },
  { y: 415, start: 14, count: 7, gap: 92 },
];

const construirBicis = () => {
  const bicis = [];
  for (const fila of FILAS) {
    if (fila.xs) {
      fila.xs.forEach((x, i) => bicis.push({ n: fila.start + i, x, y: fila.y }));
      continue;
    }
    const extra = fila.pasillo || 0;
    const ancho = (fila.count - 1) * fila.gap + extra;
    let x = CX - ancho / 2;
    for (let i = 0; i < fila.count; i++) {
      bicis.push({ n: fila.start + i, x, y: fila.y });
      x += fila.gap + (fila.pasilloTras === i + 1 ? extra : 0);
    }
  }
  return bicis;
};

const BIKES = construirBicis();
const CY = FILAS[0].y;

export const BikeMap = ({ bookedBikes, selected, onToggle, t }) => {
  return (
    <div data-testid="bike-map">
      <svg viewBox="0 0 800 470" className="w-full">
        <circle cx={CX} cy={CY} r={22} fill="rgba(197,160,89,0.15)" stroke="#C5A059" strokeWidth="1.5" />
        <text x={CX} y={CY + 4} textAnchor="middle" fontSize="9" fill="#C5A059" letterSpacing="1">
          ★
        </text>
        <text x={CX} y={CY + 46} textAnchor="middle" fontSize="10" fill="#71717a" letterSpacing="3">
          {t.instructor}
        </text>
        {BIKES.map((b) => {
          const isBooked = bookedBikes.includes(b.n);
          const isSelected = selected.includes(b.n);
          return (
            <g
              key={b.n}
              data-testid={`bike-${b.n}`}
              onClick={() => !isBooked && onToggle(b.n)}
              className={isBooked ? "cursor-not-allowed" : `cursor-pointer bike-available`}
            >
              <circle
                className="bike-circle"
                cx={b.x}
                cy={b.y}
                r={15}
                fill={isSelected ? "#C5A059" : isBooked ? "#141414" : "transparent"}
                stroke={isSelected ? "#C5A059" : isBooked ? "#232323" : "#52525b"}
                strokeWidth="1.5"
                style={{ transition: "fill 0.3s ease, stroke 0.3s ease" }}
              />
              <text
                x={b.x}
                y={b.y + 4}
                textAnchor="middle"
                fontSize="11"
                fill={isSelected ? "#000" : isBooked ? "#3f3f46" : "#a1a1aa"}
                style={{ pointerEvents: "none", fontFamily: "Inter, sans-serif" }}
              >
                {b.n}
              </text>
            </g>
          );
        })}
      </svg>
      <div className="mt-6 flex flex-wrap gap-8 justify-center text-xs text-zinc-500">
        <span className="flex items-center gap-2">
          <span className="w-3.5 h-3.5 rounded-full border border-zinc-500 inline-block" />
          {t.legendAvailable}
        </span>
        <span className="flex items-center gap-2">
          <span className="w-3.5 h-3.5 rounded-full bg-[#C5A059] inline-block" />
          {t.legendSelected}
        </span>
        <span className="flex items-center gap-2">
          <span className="w-3.5 h-3.5 rounded-full bg-[#141414] border border-[#232323] inline-block" />
          {t.legendBooked}
        </span>
      </div>
    </div>
  );
};
